import {applyMiddleware, compose, createStore, Middleware, PreloadedState} from 'redux';
import thunk from 'redux-thunk';
import {createLogger} from 'redux-logger';
import {persistStore} from 'redux-persist';
import createRootReducer, {State} from './reducer';
import {createSagaInjector, sagaMiddleware} from './sagas';

const rootReducer = createRootReducer();

const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const middlewares: Middleware[] = [thunk, sagaMiddleware];

const logger = createLogger({
   // diff: true,
});

if (process.env.REACT_APP_DEBUG) {
   // logger must be the last middleware in chain, otherwise it will log thunk and promise, not actual actions
   middlewares.push(logger);
}
export const configStore = (preloadedState?: PreloadedState<Partial<State>>) => {
   const store = createStore(
      rootReducer,
      preloadedState,
      composeEnhancers(applyMiddleware(...middlewares))
   );
   const persistor = persistStore(store);

   // Add injectSaga method to our store
   const injectSaga = createSagaInjector(sagaMiddleware.run);

   return {
      store: {
         ...store,
         injectSaga,
      },
      persistor,
   };
};

export const {store, persistor} = configStore();
